module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_6000.5d0a8766.png";